import React from "react";
import AppError from "@utils/AppError";
import { downloadXLSX } from "@utils/download";
import { useCallback, useState } from "react";
import useDialogAlert from "./useDialogAlert";
import { DownloadDoneOutlined, DownloadOutlined } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";

export const useDownloadReport = () => {
  const [icon, setIcon] = useState<JSX.Element>(<DownloadOutlined />);
  const [loading, setLoading] = useState<boolean>(false);

  const { snackbar } = useDialogAlert();

  const download = useCallback(
    async (service: () => Promise<Blob>) => {
      try {
        setIcon(<CircularProgress size="2rem" style={{ color: "#FFF" }} />);
        setLoading(true);

        const response = await service();

        downloadXLSX(response);

        setIcon(<DownloadDoneOutlined />);
        snackbar({
          message: "Relatório baixado com sucesso!",
          variant: "success",
          autoHideDuration: 3000,
        });
      } catch (error) {
        if (error instanceof AppError) {
          snackbar({
            message: `Não foi possível fazer download do relatório: ${error.message}`,
            variant: "error",
            autoHideDuration: 3000,
          });
        }
      } finally {
        setTimeout(() => {
          setIcon(<DownloadOutlined />);
          setLoading(false);
        }, 2000);
      }
    },
    [snackbar]
  );

  return { download, icon, loading };
};
